module.exports = __webpack_public_path__ + "img/logo2.4edeeba7.png";